<template>
  <section
    class="space-y-4 p-4 h-full p-4 box-border overflow-y-auto overflow-x-hidden"
  >
    <viewTitle title="业务管理 / 其他设置"></viewTitle>
    <!-- 内容 begin -->
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="逗留告警人员" prop="warning_user_ids">
        <tableSelector
          title="请选择推送人员"
          v-model="form.warning_user_ids"
          :rows.sync="warning_user_list"
          :columns="userColumns"
          :params="user_params"
          :http-request="userLoad"
          @close="onCloseSelector"
        >
          <div class="mb-4" slot="search">
            <el-input
              class="w-60"
              v-model="user_params.keyword"
              clearable
              placeholder="搜索账号、手机号和联系人"
            ></el-input>
            <span style="margin-left: 10px;">角色：</span>
            <el-select
              multiple
              v-model="user_params.role_id"
              clearable
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in baseRoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div slot="content">
            <span v-if="warning_user_list.length > 0">{{
              warning_user_list | formatUser
            }}</span>
          </div>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择人员</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="车辆报备审批飞书接收人" prop="car_report_feishu_user_ids">
        <tableSelector
          title="请选择飞书接收人"
          v-model="form.car_report_feishu_user_ids"
          :rows.sync="car_report_feishu_user_list"
          :columns="userColumns"
          :params="user_params"
          :http-request="userLoad"
          @close="onCloseSelector"
        >
          <div class="mb-4" slot="search">
            <el-input
              class="w-60"
              v-model="user_params.keyword"
              clearable
              placeholder="搜索账号、手机号和联系人"
            ></el-input>
            <span style="margin-left: 10px;">角色：</span>
            <el-select
              multiple
              v-model="user_params.role_id"
              clearable
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in baseRoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div slot="content">
            <span v-if="car_report_feishu_user_list.length > 0">{{
              car_report_feishu_user_list | formatUser
            }}</span>
          </div>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择人员</el-link
          >
        </tableSelector>
      </el-form-item>
    </el-form>
    <!-- 内容 end -->
    <div style="height: 56px;"></div>
    <div
      class="absolute bottom-0 left-0 space-x-4 bg-white w-full px-4 py-2 box-border z-50 border-t border-solid border-gray-200"
    >
      <el-button size="small" @click="onSave" type="primary">保 存</el-button>
    </div>
  </section>
</template>
<script>
import tableSelector from "@/components/tableSelector/index.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      warning_user_list: [],
      car_report_feishu_user_list: [],
      user_params: {
        keyword: ""
      },
      form: {
        warning_user_ids: [],
        car_report_feishu_user_ids: []
      },
      rules: {
        warning_user_ids: [
          {
            required: false,
            message: "请选择逗留告警人员",
            trigger: "change",
            type: "array"
          }
        ],
        car_report_feishu_user_ids: [
          {
            required: false,
            message: "请选择车辆报备审批飞书接收人",
            trigger: "change",
            type: "array"
          }
        ]
      },
      userColumns: [
        { label: "联系人", prop: "contact" },
        { label: "账号", prop: "account" },
        { label: "角色", prop: "role_name" }
      ]
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "baseRole"]),
    baseRoleList() {
      return this.baseRole.filter(e => {
        const insider = [
          "admin",
          "sampler",
          "sample_receiver",
          "stevedore",
          "gate_guard"
        ].includes(e.code);
        const isCustom = e.code.indexOf("custom-") === 0;
        return insider || isCustom;
      });
    }
  },
  components: {
    tableSelector
  },
  methods: {
    // 加载人员选择器数据。
    async userLoad(params) {
      const defaultRoleId = this.baseRoleList.map(e => e.id).join(",");
      const dataObj = await this.$common.http({
        url: "/api/contact/search",
        data: {
          ...params,
          role_id:
            params.role_id && params.role_id.length > 0
              ? params.role_id.join(",")
              : defaultRoleId,
          is_select: 1,
          limit: params.page_size,
          offset: (params.page - 1) * params.page_size,
          type: 2
        }
      });
      return {
        data: dataObj.data.data.items,
        total: dataObj.data.data.total
      };
    },
    // 保存其他设置。
    onSave() {
      this.$refs.form.validate(vaild => {
        if (vaild) {
          this.$confirm("确认保存配置?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(async () => {
            try {
              await this.$common.http({
                url: "/api/queue/admin/save_other_setting",
                data: this.form
              });
              this.$message.success("保存成功！");
              setTimeout(() => {
                this.getOtherSetting();
              }, 1000);
            } catch (error) {}
          });
        }
      });
    },
    // 关闭人员选择器时重置检索条件。
    onCloseSelector() {
      this.user_params = {
        keyword: "",
        role_id: ""
      };
    },
    // 查询其他设置并完成页面回显。
    async getOtherSetting() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/query_other_setting"
        });
        // 关键步骤：同时回显“逗留告警接收人”和“车辆报备审批飞书接收人”。
        const {
          warning_users = [],
          car_report_feishu_users = []
        } = dataObj.data.data || {};
        this.warning_user_list = warning_users.map(item => {
          return {
            ...item,
            contact: item.name
          };
        });
        this.car_report_feishu_user_list = car_report_feishu_users.map(item => {
          return {
            ...item,
            contact: item.name
          };
        });
        this.$set(
          this.form,
          "warning_user_ids",
          warning_users.map(e => e.id)
        );
        this.$set(
          this.form,
          "car_report_feishu_user_ids",
          car_report_feishu_users.map(e => e.id)
        );
      } catch (error) {}
    }
  },
  created() {
    this.getOtherSetting();
  },
  filters: {
    formatUser(list) {
      return list.map(e => e.contact).join("；");
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input__validateIcon {
  display: none;
}
</style>
